import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrendingSearch } from '../../../../models/global-search.model';

@Component({
  selector: 'app-trending-searches',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './trending-searches.component.html',
  styleUrl: './trending-searches.component.scss',
})
export class TrendingSearchesComponent {
  @Input() items: TrendingSearch[] = [];
  @Output() select = new EventEmitter<string>();

  formatCount(count: number): string {
    if (count >= 1_000_000) return `${(count / 1_000_000).toFixed(1)}M`;
    if (count >= 1000) return `${(count / 1000).toFixed(1)}k`;
    return `${count}`;
  }
}
